import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { classNames } from 'uitk-react-utils';
import { UitkMediaGalleryThumbnail } from './uitk-media-gallery-thumbnail.esm.js';
import styles from './uitk-media-gallery.css';

var getClassNameList = classNames.bind(styles);
var UitkMediaGalleryThumbnailView = /** @class */ (function (_super) {
    __extends(UitkMediaGalleryThumbnailView, _super);
    function UitkMediaGalleryThumbnailView(props) {
        var _this = _super.call(this, props) || this;
        _this.onImageSelect = _this.onImageSelect.bind(_this);
        return _this;
    }
    UitkMediaGalleryThumbnailView.prototype.onImageSelect = function (index) {
        var onImageSelected = this.props.onImageSelected;
        onImageSelected(index);
    };
    UitkMediaGalleryThumbnailView.prototype.render = function () {
        var _this = this;
        var _a = this.props, focusIndex = _a.focusIndex, images = _a.images, columns = _a.columns, space = _a.space, tag = _a.tag, className = _a.className, imagesRatio = _a.imagesRatio, containerRef = _a.containerRef;
        var cssClassNames = getClassNameList('uitk-media-gallery-thumbnail-view', className);
        return images ? (React.createElement(UitkLayoutGrid, { tag: tag, columns: columns, className: cssClassNames, space: space }, images &&
            images.length > 0 &&
            images.map(function (image, index) {
                var onSelect = function () { return _this.onImageSelect(index); };
                return (React.createElement(UitkLayoutGridItem, { key: index },
                    React.createElement(UitkMediaGalleryThumbnail, __assign({}, image, { index: index, imagesRatio: imagesRatio, onImageSelected: onSelect, focusIndex: focusIndex, containerRef: containerRef }))));
            }))) : null;
    };
    UitkMediaGalleryThumbnailView.displayName = 'UitkMediaGalleryThumbnailView';
    UitkMediaGalleryThumbnailView.defaultProps = {
        columns: { auto_fill: 'twenty_four' },
        focusIndex: 0,
        space: 'two',
        tag: 'ul'
    };
    return UitkMediaGalleryThumbnailView;
}(React.PureComponent));

export { UitkMediaGalleryThumbnailView };
